import _classCallCheck from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createForOfIteratorHelper from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

function createConditionEval(condition) {
  return function conditionEval(input) {
    if (typeof condition === 'boolean') {
      return condition;
    }

    return Object.keys(condition).every(function (prop) {
      var value = condition[prop];

      if (value === true) {
        return prop in input;
      } else if (value === false) {
        return !(prop in input);
      } else if (typeof value === 'function') {
        return value(input[prop]);
      } else if (Array.isArray(value)) {
        return value.includes(input[prop]);
      } else {
        return input[prop] === value;
      }
    });
  };
}

function parsePropStatement(prop, toSource) {
  var inputProp;
  var outputProp;
  var convert;
  var condition;

  if (typeof prop === 'string') {
    inputProp = outputProp = prop;
  } else if (prop) {
    inputProp = toSource ? prop.target : prop.source;
    outputProp = toSource ? prop.source : prop.target;

    if (prop.convert) {
      convert = toSource ? prop.convert.toSource : prop.convert.toTarget;
    }

    if (prop.when) {
      condition = toSource ? prop.when.target : prop.when.source;

      if (condition != null) {
        condition = createConditionEval(condition);
      }
    }
  } else {
    return null;
  }

  inputProp = [].concat(inputProp).filter(Boolean);
  outputProp = [].concat(outputProp).filter(Boolean);
  return {
    inputProp: inputProp,
    outputProp: outputProp,
    convert: convert,
    condition: condition
  };
}

function createConverter(props, toSource) {
  toSource = toSource === Translator.CONVERT_TO_SOURCE;
  props = props.map(function (prop) {
    return parsePropStatement(prop, toSource);
  }).filter(Boolean);
  return function converter(input) {
    var output = {};

    var _iterator = _createForOfIteratorHelper(props),
        _step;

    try {
      var _loop = function _loop() {
        var _step$value = _step.value,
            inputProp = _step$value.inputProp,
            outputProp = _step$value.outputProp,
            convert = _step$value.convert,
            condition = _step$value.condition;

        if (outputProp.length === 0) {
          return "continue";
        } else if (condition && !condition(input)) {
          return "continue";
        } else if (inputProp.length !== 0 && inputProp.every(function (prop) {
          return !(prop in input);
        })) {
          return "continue";
        }

        var outputData = inputProp.map(function (prop) {
          return input[prop];
        });

        if (convert) {
          var converted = convert.apply(input, outputData);
          outputData = outputProp.length === 1 ? [converted] : converted;
        }

        outputProp.forEach(function (prop, index) {
          var value = outputData[index];

          if (value !== undefined) {
            output[prop] = value;
          }
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ret = _loop();

        if (_ret === "continue") continue;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return output;
  };
}

var Translator = function Translator(props) {
  _classCallCheck(this, Translator);

  this.convertToSource = createConverter(props, Translator.CONVERT_TO_SOURCE);
  this.convertToTarget = createConverter(props, Translator.CONVERT_TO_TARGET);
};

Translator.CONVERT_TO_SOURCE = Symbol('convert to source');
Translator.CONVERT_TO_TARGET = Symbol('convert to target');
export { Translator };